import {Text} from 'components';

export const WorkTitle: React.FC = () => {
  return (
    <Text variant="body2" sx={{fontWeight: 'bold'}}>
      {'Work'}
    </Text>
  );
};
